import { useCallback } from "react";
import { useCurrentAccountId } from "@zapier/identity";
import emitUserInteractionEvent, {
  UserInteractionName,
} from "./emitUserInteractionEvent";

/** Where the user clicked Trash from, so the entry points are comparable. */
export type TrashNavClickEntryPoint = "sidebar" | "header" | "mobile-tabs";

export function useEmitTrashNavClickEvent() {
  const accountId = useCurrentAccountId();

  const emit = useCallback(
    (entryPoint: TrashNavClickEntryPoint) => {
      emitUserInteractionEvent({
        accountId,
        interactionName: UserInteractionName.TrashNavClick,
        optionSelected: entryPoint,
      });
    },
    [accountId],
  );

  return {
    emit,
  };
}
